import { inject } from "@angular/core";
import { userBalance } from "../utils/token.interface";
import { ContractUtils } from "../utils/contract-utils";

/**
 * Checks if user is verified and valid.
 * If user is not verified or valid, it will open the verification modal.
 * @param user - User object.
 * @param verificationModal - Bootstrap modal object.
 * @returns {boolean} - True if user is verified and valid, false otherwise.
 */
export function isUserVerifiedAndValid(user: any, verificationModal: any, regulated: boolean): boolean {
    if (regulated === false && (user?.email_verified === false || user?.is_valid === false)) {
        verificationModal?.show();
        return false;
    }
    return true;
}

/**
 * Handles array itrator
 * @param value 
 * @param action 
 * @param callBack 
 */
export async function handleArrayItrator(value: Array<{ [key: string]: any }>, action: string[], callBack: (result: any) => any) {
    let overLoppedvalues: any
    overLoopValue([value, action], async (status: boolean) => {
        if (status) {
            overLoppedvalues = await customizeArryaIteration(value, action)
            callBack(overLoppedvalues);
            return ''
        } else {
            return "value isn't an array!!.Kindly check your values. "
        }
    })

}

/**
 * Checks valueis array
 * @param value 
 * @returns  
 */
function checkValueisArray(value: any) {
    return Array.isArray(value)
}

/**
 * Overs loop value
 * @param request 
 * @param callBack 
 */
function overLoopValue(request: Array<{ [key: string]: any }> | string[], callBack: (status: boolean) => any) {
    let result: boolean = false
    request.forEach((res: any) => {
        if (checkValueisArray(res)) {
            result = true
        }
    })
    callBack(result)
}

/**
 * Customizes arrya iteration
 * @param requestedArray 
 * @param iterationKey 
 */
function customizeArryaIteration(requestedArray: any, iterationKey: string[]) {
    let result: any = []
    requestedArray.forEach((element: any) => {
        for (const key of iterationKey) {
            if (Object.prototype.hasOwnProperty.call(element, key)) {
                result.push(element[key])
            }
        }
    });
    return result
}

/**
 * Gets the respected key values
 * @param value 
 * @param givenRequest 
 */
async function getTheRespectedKeyValues(value: { [key: string]: any }, givenRequest: any) {
    let result = []
    for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
            result.push(givenRequest[key])
        }
    }
    return result;
}

export function handleStoragefeeCalculation(category: string, data: { [key: string]: any }) {
    const overallPercentage = data['percentage'] ? data['percentage'] / 100 : ''

    /**
     * Nbottels gold calculation
     * @param [apprValue] 
     * @param [percentage] 
     * @param [payingDays] 
     * @returns  
     */
    let goldCalculation = (apprValue: any = 0, percentage: any = 0, payingDays: any = 0) => {
        const result = Number(apprValue) * Number(percentage) * Number(payingDays)
        const modify_result = result.toFixed(2)
        return Number(modify_result)
    }
    /**
     * Nbottels wine calculation
     * @param [Nbottels] 
     * @param [fixedAmount] 
     * @param [payingDays] 
     * @returns  
     */
    let wineCalculation = (Nbottels: any = 0, fixedAmount: any = 0, payingDays: any = 0) => {
        const result = Number(Nbottels) * Number(fixedAmount) * Number(payingDays)
        const modify_result = result.toFixed(2)
        return Number(modify_result)
    }

    switch (category) {
        case "gold":
            return goldCalculation(data['appraisal_value'], overallPercentage, data['total_count_days'])
            break;
        case "wine":
            return wineCalculation(data['no_of_bottels'], data['fixed_amount'], data['total_count_days'])
            break;
        default:
            break;
    }

}

/**
* Params loan detail component
* @param userAmountCheck * @param [balance]  * @param [decimal]  * @param [amount] 
* @param callBack isHave ==> ite return the user have enough amount or not.
*/
export async function _handleInSufficientBalance(userAmountCheck: Partial<userBalance>) {
    const { decimal, balance, amount } = userAmountCheck;
    let ishaveSuffAmnt = true
    if (Number(balance) < Number(amount)) ishaveSuffAmnt = false
    return ishaveSuffAmnt
}

export const FOUR_CORNER_WINE_URL = "https://v22-services.hub.wine/xml/4CW-REALWORLD-4EB84B"

export const STORAGE_FEE_CATEGORY = ['wine', 'gold', 'silver', 'platinum','palladium']